export const convertToBase64 = (value: string) => btoa(value);
